<template>
  <div class="all">
    <div class="width100 margin-auto">
      <!-- 检索 -->
      <div class="backwhite">
        <table class="width100 margin-auto text-ellipsis margin-top40">
          <tr>
            <td class="tdtit">产品名称</td>
            <td class="tdcont">{{ formtitle }}</td>
            <td class="tdtit">立项时间</td>
            <td class="tdcont">{{ formstart_at }}</td>
          </tr>
          <tr>
            <td class="tdtit">产品类别</td>
            <td class="tdcont">{{ formcate_idbig }}__{{ formcate_id }}</td>
            <td class="tdtit">上游产业</td>
            <td class="tdcont">{{ formupsteam }}</td>
          </tr>
          <tr>
            <td class="tdtit">下游产业</td>
            <td class="tdcont">{{ formdownsteam }}</td>
            <td class="tdtit">名企配套</td>
            <td class="tdcont">{{ formwell_known_used }}</td>
          </tr>
          <tr>
            <td class="tdtit">技术关键词</td>
            <td class="tdcont">{{ formtech_keyword }}</td>
            <td class="tdtit">技术垄断者</td>
            <td class="tdcont">{{ formtech_controller }}</td>
          </tr>
          <tr>
            <td class="tdtit">关联竞争对手</td>
            <td class="tdcont">{{ formopponent }}</td>
            <td class="tdtit">关联专利</td>
            <td class="tdcont">{{ formpatent }}</td>
          </tr>
        </table>
        <div class="width100 margin-top20">
          <p class="textalign-left">产品封面</p>
          <div class="textalign-left width20">
            <el-image
              :src="picturehead + formpicture"
              class="width100 hight140 margin-top20"
            >
              <div slot="error" class="image-slot">
                <img
                  class="pictureimg"
                  src="@/assets/barsvg/tpjzsb.svg"
                  alt=""
                />
              </div>
            </el-image>
          </div>
        </div>
        <div class="width100">
          <p class="textalign-left margin-top20">附件</p>
          <div class="margin-auto flex-leftwrap margin-top20">
            <div v-for="(item, index) in filebox" :key="index" class="width20">
              <div class="filebox">
                <el-image
                  :src="picturehead + item.url"
                  class="width100 hight140 border-rd3"
                ></el-image>
                <div class="margin-bot10 f12">
                  <p class="text-ellipsis textalign-left">
                    {{ item.original_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="width100">
          <p class="textalign-left margin-top20">产品详情</p>
          <div
            class="textalign-left margin-top20 lineheight30"
            style="color: #969eac"
            v-html="formremark"
          ></div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import BUS from "@/BUS/BUS";
import { entproductdetail } from "@/api/Center/Center.api";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      listColumn: false,
      picColumn: true,
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisiblepro: false,
      mentSuccess: true,
      serchkey: true,
      formtitle: "",
      formstart_at: "",
      formupsteam: "",
      formcate_id: "",
      formcate_idbig: "",
      formdownsteam: "",
      formwell_known_used: "",
      formtech_keyword: "",
      formpatent: "",
      formopponent: "",
      formtech_controller: "",
      formremark: "",
      formpicture: "",
      formpictureurl: "",
      mousechange: -1,
      mousechanges: -1,
      filebox: [],
      picturehead: "",
      optionb: [],
      optionm: [],
      page: {},
      rowid: "",
      columns: false,
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
      files: [],
    };
  },

  methods: {},
  created() {
    this.picturehead = window.g.Apisrc;
    entproductdetail({
      id: window.sessionStorage.getItem("productdetaliyid"),
    }).then((res) => {
      if (res.data.code == 200) {
        this.formtitle = res.data.data.title;
        this.formstart_at = res.data.data.start_at;
        this.formupsteam = res.data.data.upsteam;
        this.formcate_id = res.data.data.cate.name;
        this.formcate_idbig = res.data.data.bigcate.name;
        this.formdownsteam = res.data.data.downsteam;
        // this.formwell_known_used = res.data.data.well_known_used;
        this.formtech_keyword = res.data.data.tech_keyword;
        this.formpatent = res.data.data.patent;
        this.formopponent = res.data.data.opponent;
        this.formtech_controller = res.data.data.tech_controller;
        this.formremark = res.data.data.remark;
        this.formpictureurl = res.data.data.picture;
        this.formpicture = res.data.data.picture;
        this.filebox = res.data.data.files;
        this.page = res.data.data;
        if (res.data.data.well_known_used == 0) {
          this.formwell_known_used = "否";
        } else {
          this.formwell_known_used = "是";
        }
        this.filebox = res.data.data.files;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("productdetaliyid", (data) => {
      //    获取详情
      entproductdetail({
        id: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.formtitle = res.data.data.title;
          this.formstart_at = res.data.data.start_at;
          this.formupsteam = res.data.data.upsteam;
          this.formcate_id = res.data.data.cate.name;
          this.formcate_idbig = res.data.data.bigcate.name;
          this.formdownsteam = res.data.data.downsteam;
          // this.formwell_known_used = res.data.data.well_known_used;
          this.formtech_keyword = res.data.data.tech_keyword;
          this.formpatent = res.data.data.patent;
          this.formopponent = res.data.data.opponent;
          this.formtech_controller = res.data.data.tech_controller;
          this.formremark = res.data.data.remark;
          this.formpictureurl = res.data.data.picture;
          this.formpicture = res.data.data.picture;
          this.filebox = res.data.data.files;
          this.page = res.data.data;
          if (res.data.data.well_known_used == 0) {
            this.formwell_known_used = "否";
          } else {
            this.formwell_known_used = "是";
          }
          this.filebox = res.data.data.files;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
}

::v-deep .el-transfer__button {
  border-radius: 50%;
  padding: 12px;
  display: block;
  margin-left: 0px;
}
::v-deep .el-transfer-panel {
  width: 250px;
}
::v-deep .el-transfer__button:first-child {
  margin-bottom: 10px;
}
.preservation {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
}
.filebox {
  width: 90%;
  height: 140px;
  margin: 0 0 40px 0;
  /* border: 1px solid #efefef; */
  position: relative;
}
.fileboxs {
  width: 90%;
  height: 160px;
  margin: 0 0 20px 0;
  /* border: 1px solid #efefef; */
  position: relative;
}
.pictureimg {
  width: 100%;
  height: 168px;
}

.picturecont {
  width: 100%;
  height: 168px;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  /* top: 50%; */
  color: white;
  /* text-align: center; */
  z-index: 2;
}
.picspan {
  position: relative;
  top: 50%;
  z-index: 3;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  /* text-align: center; */
  /* border: 1px dashed #e5e5e5; */
  position: relative;
  right: 140px;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}

.pictureconts {
  width: 100%;
  height: 100%;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  /* top: 50%; */
  color: white;
  /* text-align: center; */
  z-index: 2;
}
.pictureimgs {
  width: 100%;
  height: 120px;
}
.fileboxs {
  width: 100%;
  height: 120px;
  margin: 0 0 50px 0;
  /* border: 1px solid #efefef; */
  position: relative;
}
.picspans {
  position: relative;
  top: 40%;
  z-index: 3;
}
.uploaddragger >>> .el-upload {
  width: 100%;
}
.uploaddragger >>> .el-upload-dragger {
  width: 100%;
  margin: auto;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>